module.exports = __webpack_public_path__ + "static/media/pill_shado.89e94ed5.webp";